<template>
    <v-container class="bg fullHeight d-flex " fluid>
        <OutlinedCard
            :title="$t('modules.portalalumno.reglamento.reglamentoConfirm.breadcrumbs.title')"
            :subtitle="$t('modules.portalalumno.reglamento.reglamentoConfirm.breadcrumbs.description')"
            style="height: max-content"
        >
            <v-card class="reglamento-container mt-3" ref="reglamentoCard">
              <div v-for="chapter in chapter" :key="chapter.id">
                <v-card-title class="text-h5 primary white--text pa-6">
                  {{ chapter.name }}
                </v-card-title>
                <div v-for="subchapter in chapter.subchapter" :key="subchapter.id" class="pa-6">
                  <v-card-subtitle class="text-h6 font-weight-bold py-4">
                    {{ subchapter.name }}
                  </v-card-subtitle>
                  <v-card-text >
                    <div v-html="subchapter.content"></div>
                  </v-card-text>
                  <v-divider></v-divider>
                </div>
              </div>
            </v-card>
            <v-container >
                <v-row>
                  <v-btn
                  v-show="showScrollButton"
                  fab
                  small
                  color="primary"
                  class="btn-scroll"
                  @click="scrollToBottom"
                  >
                  <v-icon>mdi-arrow-down</v-icon>
                </v-btn>
              </v-row>
              <v-row class="pt-7">
                <v-col class="d-flex justify-center" cols="4">
                  <a
                    :href="require('@/assets/documents/Reglamento_Institucional_Teclab_2021.pdf')" target="_blank">
                    <v-icon class="pe-2" large color="blue">mdi-cloud-download-outline</v-icon>
                    {{$t('modules.portalalumno.reglamento.reglamentoConfirm.pdf')}}
                  </a>
                </v-col>
                <v-col class="d-flex justify-center" cols="4">
                    <div v-if="showCheck" class="d-flex">
                        <v-checkbox
                          v-model="accept"
                          color="primary"
                          class="ma-0"
                        ></v-checkbox>
                        <label class="pt-1" for="chkAccept"><strong>{{$t('modules.portalalumno.reglamento.reglamentoConfirm.condiciones.title')}}</strong></label>
                    </div>
                    <div v-else>
                      <p>{{$t('modules.portalalumno.reglamento.reglamentoConfirm.condiciones.subtitle')}}</p>
                    </div>
                </v-col>
                <v-col class="d-flex justify-end" cols="4">
                    <Button
                        @clicked="confirm"
                        :disabled="!accept"
                        :text="$t('actions.accept')"
                        :successText="$t('actions.created')"
                        :errorText="$t('actions.error')"
                    ></Button>
              </v-col>
            </v-row>
          </v-container>
        </OutlinedCard>
        <FirmNewPP v-if="$isTeclab" :open="!!$route.query.pp || showModalFirmNewPP" @close="showModalFirmNewPP = false" />
    </v-container>
</template>


<script>
    import OutlinedCard from '@/components/OutlinedCard/OutlinedCard';
    import Button from '@/components/Button/Button';
    import FirmNewPP from '../../Dashboard/Components/FirmNewPP.vue'
    import AuthService from '@/plugins/auth.service';
    import ListStudents from '@/constants/listStudents';
    import { mapGetters } from 'vuex';
    import { $student,$rules } from  '../Services';
    import Configuration from '../../../../core/constants/configuration';

    export default {
        components: {
            OutlinedCard,
            Button,
            FirmNewPP,
        },
        name: 'ReglamentoConfirm',
        data() {
            return {
                chapter:{},
                accept: false,
                showModalFirmNewPP: false,
                showScrollButton: false,
                showCheck: false
            }
        },
        computed:{
            ...mapGetters({
                studentId: 'commons/getStudentId',
            }),
        },
        methods: {
            async fetchRegulation() {
              try{
                const {data} = await $rules.find('chapters/general')
                this.chapter = data
              }catch(error){
                return error
              }
            },
            async confirm(){
                await $student.update(null, null, { params: { studentId: this.studentId, type: 'GENERAL' } }, 'signPpTermCondition' )
                await this.$store.dispatch('commons/initData')
                this.$router.push('/dashboard')
            },
            handleScroll(e) {
                const element = e.target
                this.showScrollButton = element.scrollHeight - element.scrollTop - element.clientHeight > 80
            },
            inTheEnd(event) {
                const elemento = event.target
                this.showCheck = Math.abs(elemento.scrollHeight - elemento.scrollTop - elemento.clientHeight) < 2
            },
            listeners() {
                this.$refs.reglamentoCard.$el.addEventListener('scroll', this.handleScroll)
                this.$refs.reglamentoCard.$el.addEventListener('scroll', this.inTheEnd)
            },
            scrollToBottom() {
                const element = this.$refs.reglamentoCard.$el
                element.scrollTo({
                    top: element.scrollHeight,
                    behavior: 'smooth'
                })
            }
        },
        async mounted () {
            const alumnoSeleccionado = JSON.parse(localStorage.getItem('alumnoSeleccionado'));
            const dniAlumnoBloqueado = Configuration.value('app') == 'portalalumno' && AuthService.isStudent() && alumnoSeleccionado ? ListStudents.find(
                dni => dni == alumnoSeleccionado.userData.username
            ) : null;
            this.showModalFirmNewPP = !!dniAlumnoBloqueado;
            this.fetchRegulation()
            this.listeners()
        },
        beforeDestroy() {
            this.$refs.reglamentoCard.$el.removeEventListener('scroll', this.handleScroll)
            this.$refs.reglamentoCard.$el.removeEventListener('scroll', this.inTheEnd)
        },
    }
</script>

<style lang="sass" scoped>

  .v-card.reglamento-container
    margin: auto
    max-height: 450px
    max-width: 850px
    overflow-y: auto
    box-shadow: 0 -4px 60px rgba(0, 0, 0, 0.23) !important
    border: 1px solid rgba(0, 0, 0, 0.1)
    border-radius: 27px

  .btn-scroll
    position: relative
    left: 50%
    bottom: 20%
    z-index: 999

</style>